import UserDetails from "../../../jsx/components/Dashboard/UserDetails/userdetails";

const UserDetailsWrapper = () => {
  return <UserDetails />;
};

export default constore(UserDetailsWrapper);
